var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { CookieReader } from '../storage/cookie-reader';
import { StorageKeys } from '../enums/storage-keys';
var DisplayWorkloadDirective = /** @class */ (function () {
    function DisplayWorkloadDirective(el, router, renderer, cookieReader) {
        this.el = el;
        this.router = router;
        this.renderer = renderer;
        this.cookieReader = cookieReader;
    }
    DisplayWorkloadDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function () {
            if (_this.cookieReader.getCookie(StorageKeys.WorkloadManagerUser))
                _this.renderer.removeClass(_this.el.nativeElement, 'd-none');
            else
                _this.renderer.addClass(_this.el.nativeElement, 'd-none');
        });
    };
    DisplayWorkloadDirective = __decorate([
        Directive({
            selector: '[dirDisplayWorkload]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Router,
            Renderer2,
            CookieReader])
    ], DisplayWorkloadDirective);
    return DisplayWorkloadDirective;
}());
export { DisplayWorkloadDirective };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzcGxheS13b3JrbG9hZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRpc3BsYXktd29ya2xvYWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxVQUFVLEVBQVUsU0FBUyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQ3pFLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUV6QyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sMEJBQTBCLENBQUM7QUFDeEQsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBS3BEO0lBQ0ksa0NBQW9DLEVBQWMsRUFDN0IsTUFBYyxFQUNkLFFBQW1CLEVBQ25CLFlBQTBCO1FBSFgsT0FBRSxHQUFGLEVBQUUsQ0FBWTtRQUM3QixXQUFNLEdBQU4sTUFBTSxDQUFRO1FBQ2QsYUFBUSxHQUFSLFFBQVEsQ0FBVztRQUNuQixpQkFBWSxHQUFaLFlBQVksQ0FBYztJQUFJLENBQUM7SUFFN0MsMkNBQVEsR0FBZjtRQUFBLGlCQU9DO1FBTkcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDO1lBQ3pCLElBQUksS0FBSSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLG1CQUFtQixDQUFDO2dCQUM1RCxLQUFJLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxLQUFJLENBQUMsRUFBRSxDQUFDLGFBQWEsRUFBRSxRQUFRLENBQUMsQ0FBQzs7Z0JBRTNELEtBQUksQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDLEtBQUksQ0FBQyxFQUFFLENBQUMsYUFBYSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBQ2hFLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQWJRLHdCQUF3QjtRQUhwQyxTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsc0JBQXNCO1NBQ25DLENBQUM7eUNBRTBDLFVBQVU7WUFDckIsTUFBTTtZQUNKLFNBQVM7WUFDTCxZQUFZO09BSnRDLHdCQUF3QixDQWNwQztJQUFELCtCQUFDO0NBQUEsQUFkRCxJQWNDO1NBZFksd0JBQXdCIn0=